import { NavLink } from "../res/styles/TextStyles"
import { Col, breakpoints, Container } from "../res/styles/Common"
import styled from "styled-components"
import { Link } from "react-router-dom"

const NavLinkContainer = styled.div`
    @media ${breakpoints.mobileS} {
        padding: 10px;
    }

    @media ${breakpoints.tablet} {
        padding: 20px 3vw;
    }

    @media ${breakpoints.laptop} {
        padding: 20px 5vw;
    }
`

const Logo = styled.img`
    width: 95px;
    height: 104px;
`

export function NavItemD(props) {
    return (
        <Col>
            <NavLinkContainer>
                {!props.isImage ? (
                    <Link
                        style={{ textDecoration: "none" }}
                        to={props.link}
                        onClick={() => props.onClick(props.link)}
                    >
                        <NavLink active={props.active}>{props.title}</NavLink>
                    </Link>
                ) : (
                    <Logo src={props.logo} />
                )}
            </NavLinkContainer>
        </Col>
    )
}

export function NavItemM(props) {
    return (
        <Container justify="flex-start">
            <NavLinkContainer>
                <Link
                    style={{ textDecoration: "none" }}
                    to={props.link}
                    onClick={() => props.onClick(props.link)}
                >
                    <NavLink sm active={props.active}>
                        {props.title}
                    </NavLink>
                </Link>
            </NavLinkContainer>
        </Container>
    )
}
